import { useMemo } from 'react';

import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import { Column } from '../Column/Column';
import { DevicesSelectorList } from '../DevicesSelector/DevicesSelectorList';
import { useAudioInputOptions } from './useAudioInputOptions';
import { useAudioOutputOptions } from './useAudioOutputOptions';

export function AudioDevicesOptions() {
	const { t } = useTranslationsContext();
	const { selected: selectedMicDevice, options: micDevices } = useAudioInputOptions();
	const { selected: selectedAudioDevice, options: audioDevices } = useAudioOutputOptions();

	const lists = useMemo(() => {
		return [
			{
				title: t('config.external_headphones'),
				options: audioDevices,
				selected: selectedAudioDevice,
			},
			{
				title: t('config.microphone'),
				options: micDevices,
				selected: selectedMicDevice,
			},
		];
	}, [micDevices, audioDevices, selectedAudioDevice, selectedMicDevice]);

	return (
		<Column $gap={18}>
			<DevicesSelectorList lists={lists} />
		</Column>
	);
}
